import React, { FC, useState } from "react";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { startAddRow } from "../../actions/rowListAction";
import { editSession, startEditSession } from "../../actions/sessionListAction";
import { AppState } from "../../reducers/rootReducer";
import { Modes, SectionList } from "../../utils/constants";
import { ItemTypes } from "../../utils/itemTypes";
import RowElement from "../elementComponents/RowElement";
import Modal from 'react-modal';
import './workingpanel.scss';
import produce from "immer";

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    color                 : '#fff',
    backgroundColor       : '#222222',
  }
};

const WorkingPanelComponent: FC = () => {
  const dispatch = useDispatch();
  const sessionState = useSelector((state: AppState) => state.session);
  const rowState = useSelector((state: AppState) => state.rowList);
  const formState = useSelector((state: AppState) => state.formList);
  const [modalIsOpen,setIsOpen] = useState(false);
  const [sectionCount,setSectionCount] = useState(0);

  const clickHandleOnWorkingPanel = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    const newSession = produce(sessionState, (draft) => {
      draft.selectedType = "";
      draft.selectedMode = Modes.WORKING;
    });
    dispatch(startEditSession(newSession));
  };

  // handle drop elements only accept layout elements only (Row)

  const [{ isOver, isOverCurrent }, drop] = useDrop({
    accept: ItemTypes.LAYOUT,
    drop(item, monitor) {
      const didDrop = monitor.didDrop();
      const dropResult = monitor.getDropResult();
      if (didDrop) {
        return;
      }
      console.log(item);
      setIsOpen(true);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
    }),
  });

    // change backgrond color when drag over the working panel

  const backGroundHover = isOver ? " canvas-hover" : "";

  // render row list according to the selected form id

  const renderRowList = () => {
    let rowListBySelectedFrom = rowState.filter((row) => { if(row.type === 'form' && row.formId === sessionState.selectedFormId) return row});
    return rowListBySelectedFrom.map((row,i) => {
      return <RowElement row={row} index={i} />;
    });
  };

  if (sessionState.selectedFormId !== "") {

    //custome css - start
    const form = formState.filter((form) => {return form.id === sessionState.selectedFormId})[0];
    const styleObj: { [key: string]: any } = {};
    if(form) {
      for (let index = 0; index < form.cssStyles.length; index++) {
        styleObj[form.cssStyles[index].retrivedStyle] = form.cssStyles[index].value;
      }
    }    
    //custome css - end

    return (
      <div
        onClick={(e)=>{ clickHandleOnWorkingPanel(e) }}
        ref={drop}
        className={"container-fluid bg-light working-panel " + backGroundHover}
      >
        <Modal // TODO: Let's create a common modal component and use it by passing the contents.
          isOpen={modalIsOpen}
          onAfterOpen={() => { setSectionCount(1)}}
          onRequestClose={() => { setIsOpen(false)}}
          style={customStyles}
          contentLabel="Example Modal"
        >
            <h6>Select Section</h6>
            <hr className="modal-footer pb-0 pt-0"/>
          <select
              value={sectionCount}
              id="input-type"
              className="form-control theam-textbox"
              onChange={(e) => {
                setSectionCount(parseInt(e.target.value))
              }}
            >
              {SectionList.map((item, i) => {
                return (
                  <option key={i} value={item.value}>
                    {item.name}
                  </option>
                );
              })}
            </select>
           <div className="modal-footer">
              <button className="btn dark theam-btn btn-dark theam-font" onClick={ () => {dispatch(
                startAddRow(
                  {
                    type: "form",
                    formId: sessionState.selectedFormId,
                    tabId: "",
                    sortKey: rowState.length + 1,
                    rowHighlight: true,
                    height: "",
                    width: "",
                    verticalAlign: "",
                    horizontalAlign: "",
                    cssStyles: [{}],
                    remark1: "",
                    remark2: "",
                    remark3: "",
                    remark4: "",
                    createdTime: "",
                    lastUpdatedTime: "",
                  },
                  sectionCount
                )
              ); setIsOpen(false)}}><i className="fa fa-check" aria-hidden="true"></i>&nbsp;ADD</button>
              <button className="btn dark theam-btn btn-dark theam-font" onClick={() => { setIsOpen(false)}}><i className="fa fa-times" aria-hidden="true"></i>&nbsp;CLOSE</button>
            </div> 
        </Modal>
        <div className="full-screen-working-area" 
             style={{...styleObj}}>
            {renderRowList()}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={"container-fluid bg-light working-panel " + backGroundHover}
      >
        <div className="container no-selected"> NO SELECTED FORM</div>
      </div>
    );
  }
};

export default WorkingPanelComponent;
